import React from 'react';
import { cn } from '@/lib/utils';

interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
    children: React.ReactNode;
}

export const SheetBadge = React.forwardRef<HTMLDivElement, BadgeProps>(
    ({ className, children, ...props }, ref) => {
        return (
            <div
                ref={ref}
                className={cn(
                    "inline-block border border-neutral-950 dark:border-neutral-100 px-3 py-1 mb-8 text-xs font-mono font-bold uppercase tracking-wider text-foreground",
                    className
                )}
                {...props}
            >
                {children}
            </div>
        )
    }
)
SheetBadge.displayName = "SheetBadge";
